import Vue from 'vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

// Configure axios
// axios.defaults.baseURL = 'http://localhost:5000'

// Request interceptor to add auth headers
axios.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem('user'))
  if (user) {
    config.headers['X-User-Id'] = user.id
  }
  return config
})

// Response interceptor for error handling
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.code === 'ECONNREFUSED') {
      console.error('Backend connection refused. Is the server running?')
    }
    return Promise.reject(error)
  }
)
Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js